import * as React from "react";
import { Grid, Link, Typography } from "@mui/material";

import config from "../../../config";

function Copyright() {
  return (
    <Typography variant="body2" style={{ color: "#313131" }}>
      {"© "}
      {"Copyright "}
      {new Date().getFullYear()} {" TijarIA"}
    </Typography>
  );
}

function AllConditions() {
  return (
    <Typography variant="body2" style={{ color: "#313131" }}>
      <Link
        color="inherit"
        href={config.baseURL + "api/referential/CGU_TIJARIA.pdf"}
        underline="hover"
        style={{ marginTop: "10px" }}
        target="_blank"
      >
        Conditions générales d'utilisation
      </Link>
    </Typography>
  );
}

function FooterCustomized() {
  return (
    <Grid
      container
      item
      sx={{
        display: "flex",
        alignItems: "center",
        minHeight: "39px",
        backgroundColor: "#F0F0F0",
        justifyContent: "space-between",
        paddingX: "20px",
        mt: 4,
      }}
    >
      <Grid
        item
        xs={12}
        sm={6}
        md={5}
        display="flex"
        justifyContent={{
          xs: "center",
          sm: "flex-start",
          md: "flex-start",
        }}
        alignItems={"center"}
      >
        <Copyright />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={6}
        display="flex"
        justifyContent={{
          xs: "center",
          sm: "flex-end",
          md: "flex-end",
        }}
        alignItems={"center"}
        pr={{ sm: 2, md: 2.5 }}
      >
        <AllConditions />
      </Grid>
    </Grid>
  );
}

export default FooterCustomized;
